import React, { useState } from 'react';
import { STATIC_UPPSALA_SVG_URL } from '../../lib/constants';
const Select = (props) => {
    const [selectedValue, setSelectedValue] = useState(props.defaultValue);
    const handleSelectChange = (event) => {
        const newValue = event.target.value;
        setSelectedValue(newValue);
        if (props.onChange)
            props.onChange(event);
    };
    return (React.createElement("div", { style: { marginBottom: '15px', ...props.style }, className: props.className ?? '' },
        props.label && (React.createElement("label", { htmlFor: props.id, className: "form-label" }, props.label)),
        React.createElement("div", { className: "flex" },
            React.createElement("select", { id: props.id, name: props.name, value: props.value ?? selectedValue, disabled: props.disabled ?? false, onChange: handleSelectChange, className: `form-select ${renderValidationClassName()}`, style: {
                    width: '250px',
                    height: '40px',
                    border: '1px solid #ddd',
                    borderRadius: '0px',
                } }, props.children),
            React.createElement("div", { style: { width: '25px', marginLeft: '10px', display: 'flex', justifyContent: 'center' } }, renderIcon())),
        props.invalidMessage && props.valid === false ? (React.createElement("span", { style: { color: 'red' } }, props.invalidMessage)) : null));
    function renderValidationClassName() {
        if (props.valid === true)
            return 'validation-successful';
        if (props.valid === false)
            return 'validation-error';
        return '';
    }
    function renderIcon() {
        if (props.valid === true)
            return React.createElement("img", { src: STATIC_UPPSALA_SVG_URL + 'check-mark.svg', alt: "check-mark" });
        if (props.valid === false)
            return React.createElement("img", { src: STATIC_UPPSALA_SVG_URL + 'x-mark.svg', alt: "x-mark" });
        return null;
    }
};
export default Select;
